import { gql } from '@apollo/client';

export const GET_STAND_ALONE_PAGE_SECTIONS_DATA = gql`
  query standAlonePage($slug: String!) {
    standAlonePageDataBySlug(slug: $slug) {
      id
      section
      data
      schemaId {
        id
        code
      }
      layout {
        id
        code
        name
      }
    }
  }
`;

export const GET_STAND_ALONE_PAGE_DATA = gql`
  query standAlonePage($filter: StandAlonePageFilter, $paging: CursorPaging, $sorting: [StandAlonePageSort!]) {
    standAlonePages(filter: $filter, paging: $paging, sorting: $sorting) {
      edges {
        node {
          id
          name
          slug
          status
          isEnableOTPVerification
          whatsAppJoinLinkIndia
          whatsAppJoinLinkOtherIndia
          webinarId
          ctaPriceText
          pageType
          tenant {
            id
            slug
          }
          zoomLink
          zoomTrainerName
          linkedInURL
          twitterURL
          telegramURL
          shareImage
          timer
          endTimer
          layouts {
            id
            name
            code
          }
        }
      }
    }
  }
`;
